import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface ChangePasswordPayload {
  password?: string;
  newPassword?: string;
}

const useChangePasswordQuery = () => {
  const { mutateAsync, isLoading, isError, isSuccess } = useMutation((passwords: ChangePasswordPayload) =>
    api.post(API_URL.PASSWORDS, {
      password: passwords?.password,
      new_password: passwords?.newPassword,
    })
  );

  return {
    changePassword: mutateAsync,
    isError,
    isLoading,
    isSuccess,
  };
};

export default useChangePasswordQuery;
